import React, { Component } from 'react';
import * as t from './../translate';

export default class LanguageList extends Component {

    constructor (props) {
        let state;
        super(props);
        this.id = 'lang-list-'+ Math.round((Math.random()*10000000));
        state = {
            value: ''
        };
        if (this.props.selectLang !== ''){
            state.value = this.props.selectLang;
        }
        this.state = state;
        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selectLang !== ''){
            this.setState({
                value: nextProps.selectLang
            });
        }
    }

    onChange (event) {
        let state = {value: event.target.value}
        this.setState(state);
        this.props.parentCallback(state);
    }

    render () {
        let i;
        let langs = t.langsForLang(this.props.interfaceLang);
        let options = [];
        let labelText = t.t(this.props.label, this.props.interfaceLang);

        for (i = 0; i < langs.length; i++) {
            let langObj = langs[i];
            let isoCode = Object.keys(langObj)[0];
            let longLangName = langObj[isoCode];
            options.push(<option value={isoCode} key={isoCode}>{t.titleCase(longLangName)}</option>);
        }

        return (
            <div className="form-group">
                <label htmlFor={this.id} className="">{labelText}</label>
                <select id={this.id} onChange={this.onChange} value={this.state.value} className='form-control'>
                    <option value="">{t.t('choose language', this.props.interfaceLang)}</option>
                    <option disabled>──</option>
                    {options}
                </select>
            </div>
        );
    }
}

LanguageList.propTypes = {
    selectLang:     React.PropTypes.string,
    label:          React.PropTypes.string.isRequired,
    interfaceLang:  React.PropTypes.string.isRequired,
    parentCallback: React.PropTypes.func
};



/** WEBPACK FOOTER **
 ** ./src/components/LanguageList.js
 **/